class BlackLabelLoadMore {
  constructor() {
    document.addEventListener('click', this.handleClick.bind(this));
    this.sortSoldOutToEnd(document.querySelector('#product-grid'));
  }
sortSoldOutToEnd(grid) {
  if (!grid) return;

  console.log("grid items", grid.children.length);

  const items = Array.from(grid.children);

  console.log("array items", items.length);

  const available = items.filter(
  (item) => !item.querySelector('[data-sold-out="true"]')
);

const soldOut = items.filter(
  (item) => item.querySelector('[data-sold-out="true"]')
);

[...available, ...soldOut].forEach((item) => {
  grid.appendChild(item);
});
}

  async handleClick(event) {
    const button = event.target.closest('[data-bl-load-more-button]');

    if (!button || button.disabled) return;

    event.preventDefault();

    const wrapper = button.closest('[data-bl-load-more]');
    const nextUrl = wrapper?.dataset.nextUrl;

    if (!wrapper || !nextUrl) return;

    const productGridContainer = wrapper.closest('#ProductGridContainer');
    const currentGrid = productGridContainer?.querySelector('#product-grid');

    if (!productGridContainer || !currentGrid) return;

    const originalText = button.textContent;

    button.disabled = true;
    button.classList.add('is-loading');
    button.textContent = 'LOADING...';
    wrapper.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(nextUrl, {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error(`読み込みに失敗しました: ${response.status}`);
      }

      const html = await response.text();
      const parser = new DOMParser();
      const nextDocument = parser.parseFromString(html, 'text/html');

      const nextGrid = nextDocument.querySelector(
        '#ProductGridContainer #product-grid'
      );

      if (!nextGrid) {
        throw new Error('次の商品一覧が見つかりませんでした。');
      }

      const nextItems = Array.from(nextGrid.children);
      console.log("current", currentGrid.children.length);
console.log("next", nextGrid.children.length);
console.log(nextUrl);

      nextItems.forEach((item) => {
        currentGrid.appendChild(document.importNode(item, true));
      });
this.sortSoldOutToEnd(currentGrid);
      const nextLoadMore = nextDocument.querySelector(
        '#ProductGridContainer [data-bl-load-more]'
      );

      if (nextLoadMore?.dataset.nextUrl) {
        wrapper.dataset.nextUrl = nextLoadMore.dataset.nextUrl;
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = originalText;
        wrapper.removeAttribute('aria-busy');
      } else {
        wrapper.remove();
      }

      document.dispatchEvent(
        new CustomEvent('blacklabel:products-loaded', {
          detail: {
            count: nextItems.length,
          },
        })
      );
    } catch (error) {
      console.error('[Black Label MORE]', error);

      button.disabled = false;
      button.classList.remove('is-loading');
      button.textContent = 'RETRY';
      wrapper.removeAttribute('aria-busy');
    }
  }
}

if (!window.blackLabelLoadMoreInitialized) {
  window.blackLabelLoadMoreInitialized = true;
  new BlackLabelLoadMore();
}